import React, { useContext } from 'react'
import { useParams } from 'react-router-dom'
import { SearchContext } from '../../store/search-context'


const SearchSubscribeButton = ({styles}: {[key: string]: any}) => {

    const {uuid} = useParams()

    const searchCtx = useContext(SearchContext)

    return (
        <>
            {
                Object.keys(searchCtx.filters).length > 0 &&
                <button 
                    type="button" 
                    className={`btn btn-primary ${styles.subscribeButton}`} 
                    data-bs-toggle="modal" 
                    data-bs-target="#subscriptionModal"
                >
                    { uuid ? "Update subscription" : "Subscribe to this Search" }
                </button>
            }
        </>
    )
}

export default SearchSubscribeButton
